import React from 'react';

import PropTypes from 'prop-types';

import classNames from 'classnames';

import PrevArrow from 'dibs-vg/dist/react/arrow-left';
import NextArrow from 'dibs-vg/dist/react/arrow-right';

import styles from './styles.scss';

function CarouselWrapper({ disable, onNext, onPrevious, children }) {
    const className = classNames(styles.mediaCarousel, {
        [styles.disable]: disable,
    });

    return (
        <div className={className}>
            {/* Carousel */}
            {children}

            {/* Arrows */}
            <div className={styles.prev} onClick={onPrevious}>
                <PrevArrow className={styles.arrow} />
            </div>
            <div className={styles.next} onClick={onNext}>
                <NextArrow className={styles.arrow} />
            </div>
        </div>
    );
}

CarouselWrapper.propTypes = {
    disable: PropTypes.bool,
    children: PropTypes.object.isRequired,

    onNext: PropTypes.func.isRequired,
    onPrevious: PropTypes.func.isRequired,
};

export default CarouselWrapper;
